import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PricingRule {
  id: number;
  category: number;
  categoryName: string;
  type: number;
  value: number;
  isActive: boolean;
}

@Component({
  selector: 'select-pricing-rule-dialog',
  templateUrl: './select-pricing-rule-dialog.component.html',
  styleUrls: ['./select-pricing-rule-dialog.component.css']
})
export class SelectPricingRuleDialogComponent {
  selectedRuleId: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<SelectPricingRuleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rules: PricingRule[], currentRuleId: number | null }
  ) {
    this.selectedRuleId = data?.currentRuleId ?? null;
  }

  confirm() {
    this.dialogRef.close(this.selectedRuleId);
  }

  cancel() {
    this.dialogRef.close(null);
  }

  formatValue(value: number): string {
    return `$${value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}
